$('body').on('click', '.js-login-otp-btn', function(event) {
    event.preventDefault();
    var $otpForm = '<div class="form__login-otp"><div class="form-item form-section"> <label class="text-626 text--xs text-uppercase">mobile number</label><div class="form-item__input"> <input type="number" placeholder="Enter Mobile Number" data-parsley-minlength="10" data-parsley-maxlength="10" data-parsley-type="digits" data-parsley-error-message="Enter valid 10 digit number" required/><span class="focus-line"></span></div></div><div class="form-item form-section"> <label class="text-626 text--xs text-uppercase">OTP</label><div class="form-item__input d-flex justify-content-between"> <input type="number" placeholder="Enter Mobile Number" data-parsley-minlength="6" data-parsley-maxlength="6" placeholder="Enter OTP" data-parsley-type="digits" data-parsley-error-message="Enter valid 6 digit OTP" required/><span class="focus-line"></span><button class="js-resend text-btn text-98d text--sm fnt-popins fnt-500">Resend OTP</button></div></div><div class="form-nav form-navigation"> <button class="next web-btn w-100 mb-3 mb-md-4">generate otp</button><button class="web-btn w-100 mb-3 mb-md-4" style="display: none;" type="submit">LOGIN </button><button class="web-btn web-btn--transparent w-100 js-login-back">back</button></div></div>';
    $(this).parents('.login-form-wrap').append($otpForm);
    $(this).parents('.login-form-wrap').find('.form__login-email').remove();

    
$(function () {
    var $sections = $('.form-section');
  
    function navigateTo(index) {
      // Mark the current section with the class 'current'
      $sections
        .removeClass('current')
        .eq(index)
          .addClass('current');
      // Show only the navigation buttons that make sense for the current section:
     
      var atTheEnd = index >= $sections.length - 1;
      $('.form-navigation .next').toggle(!atTheEnd);
      $('.form-navigation [type=submit]').toggle(atTheEnd);
    }
  
    function curIndex() {
      // Return the current index by looking at which section has the class 'current'
      return $sections.index($sections.filter('.current'));
    }
  
    // Previous button is easy, just go back
    $('.form-navigation .previous').click(function() {
      navigateTo(curIndex() - 1);
    });
  
    // Next button goes forward iff current block validates
    $('body').on('click', '.form-navigation .next', function() {
    
        $('.login-form-wrap').parsley().whenValidate({
          group: 'block-' + curIndex()
        }).done(function() {
          navigateTo(curIndex() + 1);
         
        });
      });

  
    // Prepare sections by setting the `data-parsley-group` attribute to 'block-0', 'block-1', etc.
    $sections.each(function(index, section) {
      $(section).find(':input').attr('data-parsley-group', 'block-' + index);
    });
    navigateTo(0); // Start at the beginning
  });
   
});


$('body').on('click', '.js-login-back', function(event) {
    event.preventDefault();
    var $EmailForm = '<div class="form__login-email"><div class="form-item"> <label class="text-626 text--xs text-uppercase">Email ID</label><div class="form-item__input"> <input type="email" placeholder="Enter your Email Address" required/><span class="focus-line"></span></div></div><div class="form-item"> <label class="text-626 text--xs text-uppercase">password</label><div class="form-item__input d-flex"> <input type="password" placeholder="Enter your Password" required/><span class="focus-line"></span><button class="js-login-otp-btn text-btn text-98d text--sm fnt-popins fnt-500">Login with OTP</button></div></div><div class="form-item login-checkbox d-flex justify-content-between align-items-center"><label  class="custom-checkbox__item col-6 px-0 mb-0"><input class="d-none" type="checkbox" name="remember-me" required="required" data-parsley-multiple="remember-me"><span class="check-container"></span><span class="text-aba text-16 check-text">Remember Me</span></label><button class="js-pas-forget text-btn text-aba text-16 fnt-popins">Forgot Password?</button></div><div class="form-submit"> <button class="web-btn w-100">LOGIN</button></div></div>';
    $(this).parents('.login-form-wrap').append($EmailForm);
    $(this).parents('.login-form-wrap').find('.form__login-otp').remove();

});


$(function () {
    var $sections = $('.form-section');
  
    function navigateTo(index) {
      // Mark the current section with the class 'current'
      $sections.removeClass('current').eq(index).addClass('current');
    
      // Show only the navigation buttons that make sense for the current section:
      
    }
  
    function curIndex() {
      // Return the current index by looking at which section has the class 'current'
      return $sections.index($sections.filter('.current'));
      
    }
  
    // Previous button is easy, just go back
    $('body').on('click', '.js-resend', function(e) {
      e.preventDefault();
      navigateTo(curIndex() - 1);
      $('.login-form-wrap').find('input').val('');
    });
  
    // Next button goes forward iff current block validates
    $('body').on('click', '.form-navigation .next', function() {

        $('.login-form-wrap').parsley().whenValidate({
          group: 'block-' + curIndex()
        }).done(function() {
          navigateTo(curIndex() + 1);
         var $step1 =  $('.login-form-wrap').parsley().isValid({group: 'block-' + 0}) 
         if($step1) {
            $('.form-section').addClass('active');
         }

        });
      });

  
    // Prepare sections by setting the `data-parsley-group` attribute to 'block-0', 'block-1', etc.
    $sections.each(function(index, section) {
      $(section).find(':input').attr('data-parsley-group', 'block-' + index);
    });
    navigateTo(0); // Start at the beginning
  });
   

$('body').on('change', '.signup-head__checks input', function() {
  var $check = $(this).is(':checked');
  var $index = $(this).parents('.signup-head__checks').index();
  if($check) {
  
    $('.signup-form').find('.signup-form__item').removeClass('active');
    $('.signup-form').find('.signup-form__item').eq($index).addClass('active');
    $("html, body").animate({ scrollTop: $('.login-form').offset().top-170}, 500);
  }
});





let $StateArrya = ['karnatak', 'maharashtra', 'gujarat', 'keral'];
$StateArrya['karnatak'] = ['Bengaluru', 'Mysore', 'Hubli'];
$StateArrya['maharashtra'] = ['Mumbai', 'Pune', 'Solapur'];
$StateArrya['gujarat'] = ['Ahmdabad', 'Amreli', 'Aravalli'];
$StateArrya['keral'] = ['Kasaragod', 'Thrissur', 'Thiruvananthapuram'];

$(document).ready(function() {
 
;




  $('.selection-area').each(function() {
    var state = $(this).find('.state-menu');
  

    for(var i=0; i<=3; i++) {
      var dropItem = '<div class="item text-capitalize text-f49 text-18">'+$StateArrya[i]+'</div>';
      state.append(dropItem);
      $(this).find('.ui.dropdown').dropdown();
    }
  })


 


  $('.dropdown2').dropdown({

    
    onChange: function (value) {
 
      var $InVal = $(this).find('.select-input');
      $InVal.val(value);
      
     
      $(this).find('.parsley-errors-list').remove();
      if($(this).hasClass('state-menu')) {
        $(this).parents('.form-selection').find('.city-menu').parents('.selection').find('input').val('');
        $(this).parents('.form-selection').find('.city-menu').parents('.selection').find('.text').addClass('default').html('Select your city')
        $(this).parents('.form-selection').find('.city-menu').html('');
        var subLen = $StateArrya[value].length;
        for(var x=0; x<subLen; x++) {
          var subItem  = '<div class="item text-capitalize text-f49 text-18">'+$StateArrya[value][x]+'</div>';
          $(this).parents('.form-selection').find('.city-menu').append(subItem);
         
        }
  
      }
     

    },
    
  });
  
});

$('body').on('input', '.input-cell', function() {
  var valid =  $(this).parsley().isValid();

  if(valid) {
    $(this).parents('.form-item').find('.text-btn').prop('disabled', false);
   
    $(this).parents('form').find('.js-resend').prop('disabled', false);
  }

  else {
    $(this).parents('.form-item').find('.text-btn').prop('disabled', true);
  }
})


$('.send-otp').on('click', function(e) {
  e.preventDefault();
  clearTimeout();
$('#otp-control-time').find('.otp-control-timer').remove();
  $(this).parents('.form-item').find('.input-cell').parsley().validate() == true;
  var valid =  $(this).parents('.form-item').find('.input-cell').parsley().isValid();
 
  if(valid) {

var timeLeft = 30;
$('#otp-control-time').append(`<span class="otp-control-timer"></span>`);
var elem = document.getElementById('otp-control-time').querySelector('.otp-control-timer');
var timerId = setInterval(countdown, 1000);
$('#otp-control-time').removeClass('d-none');
$('.js-resend').addClass('d-none');
$(this).prop('disabled', true);
function countdown() {
    if (timeLeft == -1) {
        clearTimeout(timerId);
        doSomething();
    } else {
        elem.innerHTML = timeLeft;
        timeLeft--;
    }
}

function doSomething() {
  $('#otp-control-time').addClass('d-none');
 
   $('.js-resend').prop('disabled', false);
   $('.send-otp').prop('disabled', true);
   $('.js-resend').removeClass('d-none');
}
  }
})



$('body').on('click', '.js-edit', function() {

  $(this).parents('.form-item').find('.input-cell').val("").focus();
  $('.js-resend').addClass('d-none');
});
